import "./index.scss";

const Header = () => {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <div className="site-header__logo">
          <img src="/logog.png" alt="NeverOwned Logo" />
        </div>
        <div className="site-header__powered">
          <span>Powered by</span>
          <img src="/logo.png" alt="Company logo" />
        </div>
      </div>
    </header>
  );
};

export default Header;
